const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
const API_BASE_PATH = process.env.REACT_APP_API_BASE_PATH;

const parseResponseBody = async (response) => {
  // Some endpoints may return empty body (e.g., 204) or non-JSON.
  // Reading as text first avoids "Unexpected end of JSON input".
  try {
    const text = await response.text();
    if (!text) return {};

    const contentType = response.headers.get('content-type') || '';
    if (contentType.includes('application/json')) {
      return JSON.parse(text);
    }

    // Non-JSON payload: surface it as message for better debugging.
    return { message: text };
  } catch (e) {
    return {};
  }
};

export const login = async (username, password) => {
  try {
    const response = await fetch(`${API_BASE_URL}${API_BASE_PATH}/auth/login`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      credentials: 'include', // Important: include cookies
      body: JSON.stringify({ username, password }),
    });

    const data = await parseResponseBody(response);

    if (!response.ok) {
      throw new Error(data.message || `Login failed (HTTP ${response.status})`);
    }

    return data;
  } catch (error) {
    console.error('Login error:', error);
    throw error;
  }
};

/**
 * Logout - clears cookies on the backend
 */
export const logout = async () => {
  try {
    const response = await fetch(`${API_BASE_URL}${API_BASE_PATH}/auth/logout`, {
      method: 'POST',
      credentials: 'include', 
    });

    const data = await parseResponseBody(response);

    if (!response.ok) {
      throw new Error(data.message || 'Logout failed');
    }

    return data;
  } catch (error) {
    console.error('Logout error:', error);
    throw error;
  }
};


export const verifyAuth = async () => {
  try {
    const response = await fetch(`${API_BASE_URL}${API_BASE_PATH}/auth/verify`, {
      method: 'GET',
      credentials: 'include', 
    });

    const data = await parseResponseBody(response);

    if (!response.ok) {
      return { authenticated: false };
    }

    return data;
  } catch (error) {
    console.error('Verify auth error:', error);
    return { authenticated: false };
  }
};

/**
 * Refresh access token
 * Automatically called when access token expires
 */
export const refreshToken = async () => {
  try {
    const response = await fetch(`${API_BASE_URL}${API_BASE_PATH}/auth/refresh`, {
      method: 'POST',
      credentials: 'include', // Important: include cookies
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.message || 'Token refresh failed');
    }

    return data;
  } catch (error) {
    console.error('Refresh token error:', error);
    throw error;
  }
};

